import { useState } from 'react';
import { useOrganizationsQuery } from '@common/cache';
import { useOrganizationTableStore } from '../Filters/filters.store';
import { useDrawerStore } from 'store/drawer.store.ts';

export const useOrganization = () => {
  const { filters } = useOrganizationTableStore();
  const [selectedOrganizationId, setSelectedOrganizationId] =
    useState<string>('');

  const setDrawerOpen = useDrawerStore(state => state.setDrawerOpen);
  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  const {
    data = { count: 0, records: [] },
    isRefetching,
    isFetching,
  } = useOrganizationsQuery(filters);

  const entries = data.records;

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedOrganizationId('');
  };

  const handleOpenOrganizationDetails = (id: string) => {
    setSelectedOrganizationId(id);
    setDrawerOpen(true);
  };

  return {
    entries,
    totalCount: data.count,
    isLoading: isFetching || isRefetching,
    handleOpenOrganizationDetails,
    handleCloseDrawer,
    selectedOrganizationId,
    isDrawerOpen,
  };
};
